import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription
} from '../ui/dialog';

interface CustomModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
  maxWidth?:
    | 'sm'
    | 'md'
    | 'lg'
    | 'xl'
    | '2xl'
    | '3xl'
    | '4xl'
    | '5xl'
    | '6xl'
    | '7xl';
}

function CustomModal({
  open,
  onClose,
  title,
  description,
  children,
  className = '',
  maxWidth = 'md'
}: Readonly<CustomModalProps>): JSX.Element {
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl'
  };

  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
      <DialogContent
        className={`${maxWidthClasses[maxWidth]} ${className} p-8`}
        onPointerDownOutside={onClose}
        onEscapeKeyDown={onClose}
      >
        {(title || description) && (
          <DialogHeader className='px-0'>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && (
              <DialogDescription className='pt-4'>
                {description}
              </DialogDescription>
            )}
          </DialogHeader>
        )}
        <div className='mt-6 min-w-0'>{children}</div>
      </DialogContent>
    </Dialog>
  );
}

export default CustomModal;
